






















import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'

export default {
    name: 'login_part'

    data: ()->
        error: ""
        email: ""
        password: ""
        unusable: false

    methods:
        login: ()->
            self = @
            @$http.get(settings.login_url)
            .then (mresp)->
                # console.log "LOGIN PART LOGIN() cookie crsf token before set", self.$cookie.get('csrftoken')
                # self.$cookie.set('csrftoken', mresp.body.token)
                # console.log "LOGIN PART LOGIN() cookie crsf token after set", self.$cookie.get('csrftoken')
                self.$http.post(settings.login_url, {"email": @email, "password": @password})
                .then (resp)->
                    if resp.body.status == "loggedin"
                        self.$store.dispatch('set_authenticated', resp.body.datas)
                        n.success_message(resp.body.message)
                        if localStorage.getItem('selected_company')? and localStorage.getItem('selected_company').uid != ''
                            self.$router.push({path: this.$route.params.next or '/'})
                        else
                            self.$router.push({path: '/'})
                    else if resp.body.status == "unusable_password"
                        self.unusable = true
                        self.lost_password()
                    else
                        n.error("Connexion : ", resp.body.message)
            return

        lost_password: ()->
            # console.log "LOGIN PART ", @email
            @$emit("lost-password", @email, @unusable)
            return

    mounted: ()->
        self = @
        @$http.get(settings.login_url)
        .then (resp)->
            if resp.body.status == "loggedin"
                self.$store.dispatch('set_authenticated', resp.body.datas)
                # n.success_message(resp.body.message)
                # console.log "LOGIN MOUNTED ", localStorage.getItem('selected_company').uid
                if localStorage.getItem('selected_company')? and JSON.parse(localStorage.getItem('selected_company')).uid != ''
                    self.$router.push({path: this.$route.params.next or '/'})
                else
                    self.$router.push({path: '/'})
            # else
                # console.log "LOGIN PART MOUNTED cookie crsf token before set", self.$cookie.get('csrftoken')
                # self.$cookie.set('csrftoken', resp.body.token)
                # console.log "LOGIN PART MOUNTED cookie crsf token after set", self.$cookie.get('csrftoken')
}
